export default (num, call) => (...args) => setTimeout(() => call(...args), num)
